import colors from "@/colors"
import { bigCostDollars, currency, isFloat, numberFormat } from "@/support"
import { chartColors } from "@/settings"

window.big_cost_dollars = bigCostDollars
window.chartColors = chartColors
window.colors = colors
window.isFloat = isFloat
window.number_format = numberFormat
window.currency = currency
